import { openapi } from "../../openapi";
import { IRootState } from "../app/store";

export const selectHttpGetDeviceTypes = (state: IRootState) => {
  const projectNo = state.design.projectNo;
  if (!projectNo) {
    return [];
  }
  return openapi.endpoints.getMultiplacerDevicetypes.select({ projectNo })(state).data ?? [];
};

